import { useTexts } from "Store/texts";
import { FeatureToggle } from "./featureToggleTypes";
import { featureToggle } from "./featureToggleUtils";

export const useFeatureToggle = (feature: FeatureToggle): boolean => {
  const texts = useTexts();
  return featureToggle(texts.domain.featureToggles[feature]);
};
